var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAlert(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Alert_icon_2",
    "data-name": "Alert icon 2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 34,
    height: 30.6,
    viewBox: "0 0 34 30.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_60",
    "data-name": "Path 60",
    d: "M14.512,7.194a6.185,6.185,0,0,1,10.612,0l10.91,18.838a5.885,5.885,0,0,1-5.306,8.754H8.909A5.885,5.885,0,0,1,3.6,26.032Z",
    transform: "translate(-2.819 -4.187)",
    fill: "#ffbc00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_59",
    "data-name": "Path 59",
    d: "M-3969.3,23.583a1.7,1.7,0,0,1-1.7-1.689,1.7,1.7,0,0,1,1.7-1.689,1.7,1.7,0,0,1,1.7,1.689A1.7,1.7,0,0,1-3969.3,23.583Zm0-6.758a1.7,1.7,0,0,1-1.7-1.689V6.689A1.7,1.7,0,0,1-3969.3,5a1.7,1.7,0,0,1,1.7,1.689v8.447A1.7,1.7,0,0,1-3969.3,16.825Z",
    transform: "translate(3986.298 3.093)",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlert);
export default __webpack_public_path__ + "static/media/alert.63229175.svg";
export { ForwardRef as ReactComponent };